import { render } from "./PermisoList.vue?vue&type=template&id=294d4567&scoped=true"
import script from "./PermisoList.vue?vue&type=script&lang=js"
export * from "./PermisoList.vue?vue&type=script&lang=js"

import "./PermisoList.vue?vue&type=style&index=0&id=294d4567&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294d4567"]])

export default __exports__